import { docsExtensions, EFileExtension, EFileType } from '~/shared/types';
import { THUMB_EXTENSION } from '~/services/service.file';
export const getCoverLink = (bookCoverLink, awsUrl, communityCoverLink, imgSize) => {
    const prefix = awsUrl;
    const suffix = `.${THUMB_EXTENSION}`;
    const size = imgSize || '_148x168';
    return bookCoverLink
        ? `${prefix}${bookCoverLink}${size}${suffix}`
        : `${prefix}${communityCoverLink}${size}${suffix}`;
};
export const getFileLink = (path, awsUrl, extension, fileType) => {
    let prefix = '';
    if (fileType === EFileType.video) {
        prefix = '_preview.mp4';
    }
    else if (fileType === EFileType.mobileVideo) {
        prefix = '_preview_mobile_s.mp4';
    }
    else if (docsExtensions.includes(extension)) {
        prefix = `_origin.${extension}`;
    }
    return `${awsUrl}${path}${prefix || '.' + extension}`;
};
export const getFileExtension = (fileType, fileExtension) => fileType === EFileType.image ? EFileExtension.jpg : fileExtension;
